/* globals $, productObj, console, selectionState, allEngravingProducts, qtyCtrlHelpers, ShopifyAPI, alert */
console.log("product-engraving.js fired");
$(document).ready(function(){
   $('body').on('click','.ajaxcart__qty--remove', function(e){
    e.preventDefault();
    if($(this).closest('.ajaxcart__product').find('.ajaxcart__product-property.Custom_Bundle').length > 0 ){
      var arr_remove= {};
      var arr=[];
      var new_val = parseInt($(this).closest('.ajaxcart__product').find('.ajaxcart__product-property.Custom_Bundle').attr('data-prop-val'));
      $('.ajaxcart__product').each(function(i, obj) {  
        var line_id = parseInt($(this).find('.ajaxcart__product-property.Custom_Bundle').attr('data-prop-val')); 
          
        if(line_id == new_val && line_id != '' && line_id != undefined ){ 
          arr.push(0);
        }else{
          var qty = $(this).find('.ajaxcart__qty-num').val();
          arr.push(qty);
        }
      });
      console.log('arr',arr);
      jQuery.post('/cart/update.js', { 
        updates: arr,
        async: false,
        error: function(jqXHR, textStatus, errorThrown) {
          console.log('error when removing product from the cart');
        },
        success: function(item) {
         setTimeout(function(){
           ajaxCart.load();
          },500);
        }
      });
    }else{
      console.log(' $(this).attr',  $(this).attr('data-id'));
      $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {
            'id': $(this).attr('data-id'),
            'quantity': 0
          },
          dataType: 'json',
          success: function (data){
            //alert("Both Products Remove");
            setTimeout(function(){
           ajaxCart.load();
          },500);
          }
        });
      
    }
  });
	'use strict';

	if ( typeof productObj === 'undefined' ) {
		console.log( 'No productObj var for this page' );
		return;
	}

	// Cache vars
	var w = window,
		d = document;

	var engravingMap = window.engravingMap;


	/**
	 * Figure out whether selected product has both single winner and perpetual engravings
	 */

	var productHasBothEngravingTypes = false;
	var productOnlyHasSingleWinnerEngravingType = false;
	var productOnlyHasPerpetualEngravingType = false;
	(function() {
		var productVariants = productObj.variants;

		for ( var i = 0, l = productVariants.length, variantSKU; i < l; i++ ) {
			variantSKU = productVariants[ i ].sku;
			if (
				engravingMap.hasOwnProperty( variantSKU ) &&
				engravingMap[ variantSKU ]['Single Winner Engraving SKU'] !== '' &&
				engravingMap[ variantSKU ]['Perpetual Engraving SKU'] !== ''
			) {
				productHasBothEngravingTypes = true;
				break;
			}
		}
	})();

	( function() {
		if ( ! productHasBothEngravingTypes ) {
			var productVariants = productObj.variants;
			for ( var i = 0, l = productVariants.length, variantSKU; i < l; i++ ) {
				variantSKU = productVariants[ i ].sku;
				if ( ! engravingMap.hasOwnProperty( variantSKU ) ) {
					continue;
				}
				if (
					engravingMap[ variantSKU ]['Single Winner Engraving SKU'] !== ''
				) {
					productOnlyHasSingleWinnerEngravingType = true;
					break;
				}
				if (
					engravingMap[ variantSKU ]['Perpetual Engraving SKU'] !== ''
				) {
					productOnlyHasPerpetualEngravingType = true;
					break;
				}
			}

		}
	} )();

	console.log( 'Product has both product types: ', productHasBothEngravingTypes );
	console.log( 'Product only has single winner: ', productOnlyHasSingleWinnerEngravingType );
	console.log( 'Product only has perpetual: ', productOnlyHasPerpetualEngravingType );

	/**
	 * State
	 */

	var firstEngravingDetailsInputContainer = d.querySelector( '#property-fields__row-1' );
	var alternateFirstEngravingDetailsInputContainer = null;
	if ( ! firstEngravingDetailsInputContainer && document.querySelector( '.product-single__engraving' ) ) {
		console.log( 'Using alternate alternateFirstEngravingDetailsInputContainer' );
		alternateFirstEngravingDetailsInputContainer = document.querySelector( '.product-single__engraving' );
	}

	window.selectionState = {

		/************************
		 * Dynamic / State Data
		 ************************/

		selectedVariant: null,
		selectedEngravingVariant: null,

		activeInputKeys: [], // Filled via input dom search on init

		currentSelections: { // Filled via input dom search on init
			quantity: 1,
			leagueName: '',
			engravingDetails: []
		},

		numericOptionNameToProper: {},
		properOptionNameToNumeric: {},
		shortOptionNameToNumeric: {},
		numericOptionNameToShort: {},

		/************************
		 * Static Data
		 ************************/

		allVariants: w.productObj.variants,

		inputToCheckToSelector: {
			size: '.swatch.total-size',
            topper: '.swatch.topper',
			color: '.swatch.column-color',
			plaqueQuote: '.swatch.plaque-quote',
			engraving: '.swatch.engraving',
			leagueType: '.swatch.league-type',
			style: '.swatch.style'
		},

		engravingProductNameToTitleMap: {
			'perpetual': 'Perpetual Engraving',
			'single-winner': 'Single Winner Engraving'
		},

		properOptionNameToShort: {
			'Total Size': 'size',
            'Topper': 'topper',
			'Column Color': 'color',
			'Plaque Quote': 'plaqueQuote',
			'League Type': 'leagueType',
			'No Engravings': 'engravings',
			'Year': 'year',
			'Owner Name': 'ownerName',
			'Winner Name': 'winnerName',
			'Team Name': 'teamName',
			'Style': 'style'
		},
		shortOptionNameToProper: {
			size: 'Total Size',
            topper: 'Topper',
			color: 'Column Color',
			plaqueQuote: 'Plaque Quote',
			leagueType: 'League Type',
			engravings: 'No Engravings',
			year: 'Year',
			ownerName: 'Owner Name',
			winnerName: 'Winner Name',
			teamName: 'Team Name',
			style: 'Style',

			'LINE 1 - CUSTOM TEXT (NO EMOJIS)': 'Line 1',
			'LINE 2 - CUSTOM TEXT (NO EMOJIS)': 'Line 2',
			'LINE 3 - CUSTOM TEXT (NO EMOJIS)': 'Line 3',
			'LINE 4 - CUSTOM TEXT (NO EMOJIS)': 'Line 4',
		},

		/************************
		 * DomEles
		 ************************/

		inputs: {
			// filled dynamically
			size: {},
            topper: {},
			color: {},
			plaqueQuote: {},
			leagueType: {},
			engraving: {},
			style: {},

			// static
			quantity: d.querySelector( '#Quantity' ),
			leagueName: d.querySelector( '#nameue-name' ),
			engravingDetails: {
				// first row added in setFirstEngravingDetailsRow
			},
		},

		controls: {
			engravingTypeButtons: {
				perpetual: {
					selected: true,
					hidden: false,
					domEle: d.getElementById( 'perpetual-button' ),
				},
				singleWinner: {
					selected: false,
					hidden: true,
					domEle: d.getElementById( 'single-winner-button' ),
				}
			},

			addEngravingRow: d.querySelector( '#btnAdd' ),
			removeEngravingRow: d.querySelector( '#btnDel' ),

			addToCartButton: d.querySelector( '#AddToCartText' ),

			increaseQuantityButton: d.querySelector( '#AddToCartForm > div.js-qty > button.js-qty__adjust.js-qty__adjust--plus.icon-fallback-text' ),
			decreaseQuantityButton: d.querySelector( '#AddToCartForm > div.js-qty > button.js-qty__adjust.js-qty__adjust--minus.icon-fallback-text' ),
		},

		extraEngravingTypeDomEles: {
			addEngravingRow: d.querySelector( '#btnAdd' ),
			removeEngravingRow: d.querySelector( '#btnDel' ),

			engravingTopDescription: d.querySelector( '#AddToCartForm > .product-single__engraving > h4' ),
			engravingBottomDescription: d.querySelector( '#AddToCartForm > p' ),

			singleWinnerPreviewImage: d.getElementById( 'single-winner-engraving-preview' ),

			leagueNameFullPropertyField: d.querySelector( '.line-item-property__field' ),
		},

		/******************************************************
		 * Click Handlers - Used as onclick so no this usage
		 ******************************************************/

		clickHandlers: {

			// Engraving details rows

			addEngravingDetailsRow: function() {
				var allContainers = d.querySelectorAll( 'div[id^="property-fields__row-"]' );
				var newContainer = allContainers[allContainers.length - 1];
				var newIndex = newContainer.id.replace( 'property-fields__row-', '' );

				selectionState.inputs.engravingDetails[newIndex] = {
					container: newContainer,

					year: newContainer.querySelectorAll( 'input[id^="year_"]' )[0],
					teamName: newContainer.querySelectorAll( 'input[id^="team-name_"]' )[0],
					winnerName: newContainer.querySelectorAll( 'input[id^="winner-name_"]' )[0]
				};

				selectionState.setInputtedEngravingDetails();
			},
			removeEngravingDetailsRow: function() {
				// todo: absolutely the worst way to do this
				var indexToRemove = null, strI;
				for (var i = 1; i < 30; i++) {
					strI = i + '';
					if (false === selectionState.inputs.engravingDetails.hasOwnProperty(strI)) {
						indexToRemove = '' + (i - 1);
						break;
					}
				}

				delete selectionState.inputs.engravingDetails[indexToRemove];

				selectionState.setInputtedEngravingDetails();
			},

			// Single winner / perpetual buttons

			perpetualButton: function() {
              console.log('perpetualButton')
				if (selectionState.currentSelections.engravingType === 'perpetual' ) {return;}

				// flip the button colors
				//selectionState.controls.engravingTypeButtons.singleWinner.domEle.style.background = 'white';
				selectionState.controls.engravingTypeButtons.singleWinner.domEle.style.background = '#f5f5f5';//BS updated
				selectionState.controls.engravingTypeButtons.singleWinner.domEle.style.color = 'black';

				//selectionState.controls.engravingTypeButtons.perpetual.domEle.style.background = 'black';
				selectionState.controls.engravingTypeButtons.perpetual.domEle.style.background = '#244159';//BS updated
				selectionState.controls.engravingTypeButtons.perpetual.domEle.style.color = 'white';

				// show the + / - engraving row buttons
				var extraEngravingDomEles = selectionState.extraEngravingTypeDomEles;
				extraEngravingDomEles.addEngravingRow.style.display = 'inline-block';
				extraEngravingDomEles.removeEngravingRow.style.display = 'inline-block';

				// show the league name input field and input title
				extraEngravingDomEles.leagueNameFullPropertyField.style.display = 'block';

				// update text
				// extraEngravingDomEles.engravingTopDescription.textContent = "Past Year's Winners (up to 19)"; //BS removed
				extraEngravingDomEles.engravingBottomDescription = 'Engravings Ship Separate. Free Engraving includes current and past winners.';

				// hide single winner preview image
				extraEngravingDomEles.singleWinnerPreviewImage.style.display = 'none';

				// flip selected attributes on both buttons
				selectionState.controls.engravingTypeButtons.singleWinner.domEle.setAttribute( 'selected', 'false' );
				selectionState.controls.engravingTypeButtons.perpetual.domEle.setAttribute( 'selected', 'true' );

				// show engraving details rows after the first
				for (var engravingDetailsRowKey in selectionState.inputs.engravingDetails) {
					if (engravingDetailsRowKey !== '1' ) {
						for (var engravingDetailsRowInputKey in selectionState.inputs.engravingDetails[engravingDetailsRowKey]) {
							if (engravingDetailsRowInputKey === 'container' ) {continue;}
							selectionState.inputs.engravingDetails[engravingDetailsRowKey][engravingDetailsRowInputKey].parentElement.style.display = 'block';
						}
					}
				}

				// todo: this is sloppy
				// update text labels for first engraving details row to
				//   Line 1 (Year Suggested)    Line 2 (Team Name or Text)    Line 3 (Winner name or Additional Text)
				if (selectionState.inputs.engravingDetails.hasOwnProperty( '1' )) {
					var i = 1, inputLabelToSwitchTo = null;
					for (var engravingDetailsRowInputKey in selectionState.inputs.engravingDetails['1']) {
						if (engravingDetailsRowInputKey === 'container' ) {continue;}

						inputLabelToSwitchTo = selectionState.inputs.engravingDetails['1'][engravingDetailsRowInputKey].id.toUpperCase().replace( '-', ' ' );

						i += 1;
						if (inputLabelToSwitchTo) {
							var inputEle = selectionState.inputs.engravingDetails['1'][engravingDetailsRowInputKey].parentElement.querySelector( 'label' );
							if (inputEle) {
								inputEle.textContent = inputLabelToSwitchTo;
							}
						}
					}
				}

				// set state
				selectionState.setSelectedEngravingType();
				selectionState.setSelectedEngravingProduct();
			},

			singleWinnerButton: function() {
				if (selectionState.currentSelections.engravingType === 'single winner' ) {return;}

				// flip the button colors
				//selectionState.controls.engravingTypeButtons.perpetual.domEle.style.background = 'white';
				selectionState.controls.engravingTypeButtons.perpetual.domEle.style.background = '#f5f5f5';
				selectionState.controls.engravingTypeButtons.perpetual.domEle.style.color = 'black';

				//selectionState.controls.engravingTypeButtons.singleWinner.domEle.style.background = 'black';
				selectionState.controls.engravingTypeButtons.singleWinner.domEle.style.background = '#244159';
				selectionState.controls.engravingTypeButtons.singleWinner.domEle.style.color = 'white';

				// hide the + / - engraving row buttons
				var extraEngravingDomEles = selectionState.extraEngravingTypeDomEles;
				extraEngravingDomEles.addEngravingRow.style.display = 'none';
				extraEngravingDomEles.removeEngravingRow.style.display = 'none';

				// hide the league name input field and input title
				extraEngravingDomEles.leagueNameFullPropertyField.style.display = 'none';

				// update text
				// extraEngravingDomEles.engravingTopDescription.textContent = ""; //BS removed
				extraEngravingDomEles.engravingBottomDescription = 'Engravings Ship Separate.';

				// show single winner preview image
				extraEngravingDomEles.singleWinnerPreviewImage.style.display = 'block';

				// flip selected attributes on both buttons
				selectionState.controls.engravingTypeButtons.singleWinner.domEle.setAttribute( 'selected', 'true' );
				selectionState.controls.engravingTypeButtons.perpetual.domEle.setAttribute( 'selected', 'false' );

				// hide engraving details rows after the first
				for (var engravingDetailsRowKey in selectionState.inputs.engravingDetails) {
					if (engravingDetailsRowKey !== '1' ) {
						for (var engravingDetailsRowInputKey in selectionState.inputs.engravingDetails[engravingDetailsRowKey]) {
							if (engravingDetailsRowInputKey === 'container' ) {continue;}
							selectionState.inputs.engravingDetails[engravingDetailsRowKey][engravingDetailsRowInputKey].parentElement.style.display = 'none';
						}
					}
				}

				// todo: this is sloppy
				// update text labels for first engraving details row to
				//   Line 1 (Year Suggested)    Line 2 (Team Name or Text)    Line 3 (Winner name or Additional Text)
				if (selectionState.inputs.engravingDetails.hasOwnProperty( '1' )) {
					var i = 1, inputLabelToSwitchTo = null;
					for (var engravingDetailsRowInputKey in selectionState.inputs.engravingDetails['1']) {
						if (engravingDetailsRowInputKey === 'container' ) {continue;}
						if (i === 1) {
							inputLabelToSwitchTo = 'Line 1 (Year Suggested)';
						} else if (i === 2) {
							inputLabelToSwitchTo = 'Line 2 (Team Name or Text)';
						} else if (i === 3) {
							inputLabelToSwitchTo = 'Line 3 (Winner name or Additional Text)';
						} else {
							break;
						}
						i += 1;
						if (inputLabelToSwitchTo) {
							var inputEle = selectionState.inputs.engravingDetails['1'][engravingDetailsRowInputKey].parentElement.querySelector( 'label' );
							if (inputEle) {
								inputEle.textContent = inputLabelToSwitchTo;
							}
						}
					}
				}

				// set state
				selectionState.setSelectedEngravingType();
				selectionState.setSelectedEngravingProduct();
			},

		},

		/************************
		 * Gets
		 ************************/

		getSelected: function(property) {
			return this.currentSelections[property];
		},

		getSelectedVariant: function() {
			return selectionState.selectedVariant;
		},

		// check the first variant sku, there's no direct productObj.sku
		getEngravingVariantFromEngravingSKU: function(engravingSKU) {
			console.log("engravingSKU---",engravingSKU);
			console.log("allEngravingProducts---",allEngravingProducts);
			var matchedEngravingVariant = null,
				engravingProduct,
				engravingVariants,
				engravingVariant;

			for (var c = 0, numProducts = allEngravingProducts.length; c < numProducts; c++) {
				engravingProduct = allEngravingProducts[c];
				engravingVariants = engravingProduct.variants;

				for (var d = 0, numEngravingVariants = engravingVariants.length; d < numEngravingVariants; d++) {
					engravingVariant = engravingVariants[d];
					if (engravingVariant.sku === engravingSKU) {
						matchedEngravingVariant = engravingVariant;
						break;
					}
				}
			}
			console.log("matchedEngravingVariant---",matchedEngravingVariant);
			return matchedEngravingVariant;
		},

		/************************
		 * Setters - Some used as onclick so no this usage
		 ************************/

		setSelected: function(property) {
			var propertyInputs = selectionState.inputs[property];
			for (var propertyInput in propertyInputs) {
				if (propertyInputs[propertyInput] && propertyInputs[propertyInput].checked === true) {
					selectionState.currentSelections[property] = propertyInputs[propertyInput].value;
					console.log( 'Selected ' + property + ' now: ', selectionState.currentSelections[property]);
					break;
				}
			}
		},

		incrementQuantity: function(dir) { // 'up' || 'down'
			if (dir === 'up' ) {
				selectionState.currentSelections.quantity += 1;
			} else if (dir === 'down' ) {
				selectionState.currentSelections.quantity -= 1;
			}
			console.log( 'Quantity is now: ', selectionState.currentSelections.quantity);
		},

		setSelectedEngravingType: function() {

			// Check that they exist: see https://trophysmack-staging.myshopify.com/collections/rings/products/jewel-case
			var engravingTypeInputExists = false;
			for (let engravingTypeButton in selectionState.controls.engravingTypeButtons) {
				if (selectionState.controls.engravingTypeButtons[engravingTypeButton].domEle) {
					engravingTypeInputExists = true;
				}
			}

			if (false === engravingTypeInputExists) {

				// If no input use the:
				// 	productOnlyHasSingleWinnerEngravingType,
				// 	productOnlyHasPerpetualEngravingType
				// variables.
				for (let engravingTypeButton in selectionState.controls.engravingTypeButtons) {
					console.log( 'engravingTypeButton', engravingTypeButton );
					if (engravingTypeButton === 'perpetual' && productOnlyHasPerpetualEngravingType ) {
						selectionState.currentSelections.engravingType = 'perpetual';
						selectionState.controls.engravingTypeButtons[engravingTypeButton].selected = true;
						console.log( 'Selected engravingType now: ', selectionState.currentSelections.engravingType);
						break;
					} else if ( engravingTypeButton === 'singleWinner' && productOnlyHasSingleWinnerEngravingType ) {
						selectionState.currentSelections.engravingType = 'single winner';
						selectionState.controls.engravingTypeButtons[engravingTypeButton].selected = true;
						console.log( 'Selected engravingType now: ', selectionState.currentSelections.engravingType);
						break;
					}
				}

			} else {
				for (let engravingTypeButton in selectionState.controls.engravingTypeButtons) {
					if (selectionState.controls.engravingTypeButtons[engravingTypeButton].domEle.getAttribute( 'selected' ) === 'true' ) {
						selectionState.currentSelections.engravingType = selectionState.controls.engravingTypeButtons[engravingTypeButton].domEle.innerText.toLowerCase().trim();
						selectionState.controls.engravingTypeButtons[engravingTypeButton].selected = true;
						console.log( 'Selected engravingType now: ', selectionState.currentSelections.engravingType);
						break;
					}
				}
			}

		},
		setInputtedLeagueName: function() {
			if (selectionState.inputs.leagueName) {
				selectionState.currentSelections.leagueName = selectionState.inputs.leagueName.value;
				console.log( 'Inputted leagueName now: ', selectionState.currentSelections.leagueName);
			}
		},
		setInputtedEngravingDetails: function() {
			selectionState.currentSelections.engravingDetails = []; // reset

			var detailsToCheck = [
				'year',
				'teamName',
				'winnerName',
				'ownerName',
				'leagueType',

				'LINE 1 - CUSTOM TEXT (NO EMOJIS)',
				'LINE 2 - CUSTOM TEXT (NO EMOJIS)',
				'LINE 3 - CUSTOM TEXT (NO EMOJIS)',
				'LINE 4 - CUSTOM TEXT (NO EMOJIS)',
			];

			var engravingDetailsRow;
			for (var rowKey in selectionState.inputs.engravingDetails) {
				engravingDetailsRow = selectionState.inputs.engravingDetails[rowKey]; // domEle

				var engravingRowDetails = {};

				for (var i = 0, l = detailsToCheck.length; i < l; i++) {
					if (engravingDetailsRow[detailsToCheck[i]] && engravingDetailsRow[detailsToCheck[i]].value !== '' ) {
						engravingRowDetails[detailsToCheck[i]] = engravingDetailsRow[detailsToCheck[i]].value;
					}
				}
				if (Object.keys(engravingRowDetails).length > 0) {
					selectionState.currentSelections.engravingDetails.push( engravingRowDetails );
				}
			}
			console.log( 'Selected engraving details are now: ', selectionState.currentSelections.engravingDetails);
		},
		// Some products don't have some of the properties
		setSelectedProductVariant: function() {
			var allVariants = selectionState.allVariants;

			if ( allVariants.length === 1 ) {
				selectionState.selectedVariant = allVariants[0];
				console.log( 'Selected product variant now: ', selectionState.selectedVariant );
			} else {
				var optionKeyToRequiredValue = {};

				var activeInputKey;
				for ( var i = 0, l = this.activeInputKeys.length; i < l; i++ ) {
					activeInputKey = this.activeInputKeys[ i ];

					var selectedValue = this.getSelected( activeInputKey );

					var numericName = this.shortOptionNameToNumeric[ activeInputKey ];
					if ( typeof numericName !== 'undefined' ) {
						optionKeyToRequiredValue[ numericName ] = selectedValue;
					}
				}

				for (var i = 0, l = allVariants.length, variant; i < l; i++) {
					variant = allVariants[i];

					var isMatch = true;

					for (var optionKey in optionKeyToRequiredValue) {
						if (variant[optionKey] !== optionKeyToRequiredValue[optionKey]) {
							isMatch = false;
						}
					}

					if (isMatch) {
						selectionState.selectedVariant = allVariants[i];
						console.log( 'Selected product variant now matched to: ', selectionState.selectedVariant);
						break;
					}
				}
			}
		},

		setSelectedEngravingProduct: function() {
			if (typeof this.selectedVariant === 'undefined' ) {
				console.log( 'No selected variant!' );
				return;
			}
			console.log("selectionState---",selectionState);
			var selectedVariantSKU = this.selectedVariant.sku;
			for (var variantSKU in engravingMap) {
				if (variantSKU === this.selectedVariant.sku) {
					var selectedEngravingType = this.getSelected( 'engravingType' );

					console.log( 'selectedEngravingType', selectedEngravingType );

					if (selectedEngravingType === 'perpetual' ) {
						var engravingSKU = engravingMap[variantSKU]['Perpetual Engraving SKU'];
					} else if (selectedEngravingType === 'single winner' ) {
						var engravingSKU = engravingMap[variantSKU]['Single Winner Engraving SKU'];
					} else {
						console.log( 'Bad selected engraving type: ', selectedEngravingType, '!' );
					}

					console.log( 'Searching for engraving with sku: ', engravingSKU);
					this.selectedEngravingVariant = this.getEngravingVariantFromEngravingSKU(engravingSKU);

					//console.log( 'Selected engraving now: ', selectionState.selectedEngravingVariant);
					break;
				}
			}
		},


		setInputsForKey: function(key, swatchSelector) {
			if (false === this.inputs.hasOwnProperty(key)) {
				return;
			}
			var inputContainer = d.querySelector(swatchSelector);
			if (!inputContainer) {
						return false;
					}
			var inputs = inputContainer.querySelectorAll( 'input' );
			for (var i = 0, l = inputs.length; i < l; i++) {
				this.inputs[key][inputs[i].value] = inputs[i];
			}
			return true;
		},

		initializeInputSelections: function() {
			var inputFound;
			for (var inputToCheck in this.inputToCheckToSelector) {
				inputFound = this.setInputsForKey(inputToCheck, this.inputToCheckToSelector[inputToCheck]);
				if (true === inputFound) {

					// Add to active keys
					this.activeInputKeys.push(inputToCheck);

					this.currentSelections[inputToCheck] = '';

					// Add onclick handlers to inputs
					for (var input in selectionState.inputs[inputToCheck]) {
						if (!selectionState.inputs[inputToCheck][input]) {continue;}
						(function(inputToCheck) {
							selectionState.inputs[inputToCheck][input].onclick = function() {
								selectionState.setSelected(inputToCheck);
								selectionState.setSelectedProductVariant();
								selectionState.setSelectedEngravingProduct();
							};
						})(inputToCheck);
					}

					// Set initial values
					this.setSelected(inputToCheck);
				}
			}

			// Set non-dynamic inputs
			this.setSelectedEngravingType();
			this.setInputtedLeagueName();
			this.setInputtedEngravingDetails();
		},

		/************************
		 * Initialization functions
		 ************************/

		// Using productObj.options which is an immediately available array of proper names
		fillOptionNameMappings: function() {
			var productOptions = productObj.options;

			// Use basic product options to fill numeric <-> proper name mappings
			this.numericOptionNameToShort.option1 = this.properOptionNameToShort[productOptions[0]];
			this.numericOptionNameToShort.option2 = this.properOptionNameToShort[productOptions[1]];
			this.numericOptionNameToShort.option3 = this.properOptionNameToShort[productOptions[2]];

			this.numericOptionNameToProper.option1 = this.properOptionNameToShort[productOptions[0]];
			this.numericOptionNameToProper.option2 = this.properOptionNameToShort[productOptions[1]];
			this.numericOptionNameToProper.option3 = this.properOptionNameToShort[productOptions[2]];

			this.properOptionNameToNumeric[productOptions[0]] = 'option1';
			this.properOptionNameToNumeric[productOptions[1]] = 'option2';
			this.properOptionNameToNumeric[productOptions[2]] = 'option3';

			this.shortOptionNameToNumeric[this.properOptionNameToShort[productOptions[0]]] = 'option1';
			this.shortOptionNameToNumeric[this.properOptionNameToShort[productOptions[1]]] = 'option2';
			this.shortOptionNameToNumeric[this.properOptionNameToShort[productOptions[2]]] = 'option3';

		},

		setFirstEngravingDetailsRow: function() {
			if (firstEngravingDetailsInputContainer) {
				this.inputs.engravingDetails['1'] = {};
				var detailsInputsToCollect = [
					{keyName: 'year', selector: '#year'},
					{keyName: 'teamName', selector: '#team-name'},
					{keyName: 'winnerName', selector: '#winner-name'},
					{keyName: 'ownerName', selector: '#owner-name'}
				];
				for (let i = 0, l = detailsInputsToCollect.length; i < l; i++) {
					var engravingDetailDomEle = d.querySelector(detailsInputsToCollect[i].selector);
					if (engravingDetailDomEle) {
						this.inputs.engravingDetails['1'][detailsInputsToCollect[i].keyName] = engravingDetailDomEle;
					}
				}
			} else if ( alternateFirstEngravingDetailsInputContainer ) {
				console.log( 'alternateFirstEngravingDetailsInputContainer :: 2' );
				this.inputs.engravingDetails['1'] = {};
				let labels = alternateFirstEngravingDetailsInputContainer.querySelectorAll( 'label' );
				let inputs = alternateFirstEngravingDetailsInputContainer.querySelectorAll( 'input' );
				if ( labels.length && inputs.length && labels.length === inputs.length ) {
					console.log( 'Labels and inputs check passed' );
					for ( let i = 0, l = labels.length; i < l; i++ ) {
						this.inputs.engravingDetails[ '1' ][ labels[ i ].innerText ] = inputs[ i ];
					}
				}
				console.log( 'this.inputs.engravingDetails', this.inputs.engravingDetails );
			}
		},

		/************************
		 * Add To Cart Handlers
		 ************************/

		clearLeagueNameAndEngravingDetailsInputs: function() {
			// league name
			if (selectionState.inputs.leagueName) {
				selectionState.inputs.leagueName.value = '';
				selectionState.setInputtedLeagueName();
			}

			// engraving details
			var rowsToRemove = -1;
			for (var engravingDetailsRowKey in selectionState.inputs.engravingDetails) {
				rowsToRemove += 1;
				for (var engravingDetailsKey in selectionState.inputs.engravingDetails[engravingDetailsRowKey]) {
					if (selectionState.inputs.engravingDetails[engravingDetailsRowKey][engravingDetailsKey]) {
						selectionState.inputs.engravingDetails[engravingDetailsRowKey][engravingDetailsKey].value = '';
					}
				}
			}
			if (rowsToRemove > 0) {
				for (var i = 0; i < rowsToRemove; i++) {
					selectionState.controls.removeEngravingRow.click();
				}
			}
			selectionState.setInputtedEngravingDetails();
		}
	};


	// React to productHasBothEngravingTypes

	if (productHasBothEngravingTypes) { // reveal both buttons
      console.log("set style -- display");
		d.getElementById( 'engraving-buttons' ).style.display = 'block';
		// selectionState.controls.engravingTypeButtons.singleWinner.domEle.style.display = 'initial';
		// selectionState.controls.engravingTypeButtons.singleWinner.domEle.style.display = 'initial';
	} else {
		selectionState.currentSelections.engravingType = 'perpetual';
		// selectionState.getSelected( 'engravingType' ) = function() {return 'perpetual';};
	} // leave them hidden


	// Run initialization functions

	selectionState.setFirstEngravingDetailsRow();

	selectionState.initializeInputSelections();
	selectionState.fillOptionNameMappings();

	// Add onclick state changes
	if (selectionState.controls.addEngravingRow) {
		selectionState.controls.addEngravingRow.onclick = selectionState.clickHandlers.addEngravingDetailsRow;
	}
	if (selectionState.controls.removeEngravingRow) {
		selectionState.controls.removeEngravingRow.onclick = selectionState.clickHandlers.removeEngravingDetailsRow;
	}
	if (selectionState.controls.engravingTypeButtons.perpetual.domEle) {
		selectionState.controls.engravingTypeButtons.perpetual.domEle.onclick = selectionState.clickHandlers.perpetualButton;
	}
	if (selectionState.controls.engravingTypeButtons.singleWinner.domEle) {
		selectionState.controls.engravingTypeButtons.singleWinner.domEle.onclick = selectionState.clickHandlers.singleWinnerButton;
	}
	/* Error code (commented by BYI)
	selectionState.controls.increaseQuantityButton.onclick = function() {
		selectionState.incrementQuantity( 'up' );
	};
	selectionState.controls.decreaseQuantityButton.onclick = function() {
		selectionState.incrementQuantity( 'down' );
	};*/


	// Set initial product and engraving variants

	selectionState.setSelectedProductVariant();
	selectionState.setSelectedEngravingProduct();


	/**
	 * Some helpers
	 */

	window.qtyCtrlHelpers = {

		variantIdHasAssociatedEngravings: function(variantId) {
			return (
				window.productVariantIdToSku &&
				window.engravingMap &&
				window.productVariantIdToSku.hasOwnProperty(variantId) &&
				engravingMap.hasOwnProperty(window.productVariantIdToSku[variantId])
			);
		},

		disableForFlyoutByVariantId: function(variantId, cartContainer, fullContainer) {
			var associatedProductLink = cartContainer.querySelector( 'a[href*="' + variantId + '"]' );
			if (associatedProductLink) {
				fullContainer = associatedProductLink.parentElement.parentElement.parentElement;
				if (fullContainer.classList.contains( 'ajaxcart__row' )) {
					var quantityCtrl = fullContainer.querySelector( '.ajaxcart__qty' );
					if (quantityCtrl) {
						var minusQnt = quantityCtrl.querySelector( '.ajaxcart__qty--minus' );
						var plusQnt = quantityCtrl.querySelector( '.ajaxcart__qty--plus' );
						if (minusQnt) {minusQnt.remove();}
						if (plusQnt) {plusQnt.remove();}
					}
				}
			}
		}

	};

	/**
	 * Add to cart handler
	 */

	$( '#AddToCart' ).click(function(e) {

		// Collect these now before we wipe things
		selectionState.setInputtedLeagueName();
		selectionState.setInputtedEngravingDetails();

		if (!selectionState.selectedEngravingVariant || !selectionState.selectedEngravingVariant.id) {
			console.log( 'No engraving variant match: aborting add to cart functionality' );
			return;
		}

		var engravingData = {
			id: '' + selectionState.selectedEngravingVariant.id,
			quantity: '' + selectionState.currentSelections.quantity,
			properties: {}
		};

		// Only take in league name if type = perpetual
		if (selectionState.currentSelections.engravingType === 'perpetual' ) {
			engravingData.properties['League Name'] = selectionState.currentSelections.leagueName;
		}

		var shortOptionNameToProper = selectionState.shortOptionNameToProper;

		// todo: sloppy use of indexing y
		var engravingDetails = selectionState.currentSelections.engravingDetails;

		for (var i = 0, l = engravingDetails.length, engravingDetailsRow; i < l; i++) {
			engravingDetailsRow = engravingDetails[i];
			var y = 1;
			for (var engravingDetailsKey in shortOptionNameToProper) {
				if (
					engravingDetailsRow[engravingDetailsKey] &&
					engravingDetailsRow[engravingDetailsKey] !== ''
				) {
					if (selectionState.currentSelections.engravingType === 'perpetual' ) {
						var propertiesKeyName = shortOptionNameToProper[engravingDetailsKey] + ((i === 0) ? '' : ' ' + i);
						engravingData.properties[propertiesKeyName] = engravingDetailsRow[engravingDetailsKey];

					} else if (selectionState.currentSelections.engravingType === 'single winner' ) {

						console.log( 'Check here' );
						console.log( 'Check here' );
						console.log( engravingData.properties );
						console.log( engravingDetailsRow[engravingDetailsKey] );

						console.log( 'firstEngravingDetailsInputContainer', firstEngravingDetailsInputContainer )
						console.log( 'alternateFirstEngravingDetailsInputContainer', alternateFirstEngravingDetailsInputContainer )

						if ( firstEngravingDetailsInputContainer ) {

							if (y === 1) {
								engravingData.properties['Line 1 (Year Suggested)'] = engravingDetailsRow[ engravingDetailsKey ];
								y += 1;
							} else if (y === 2) {
								engravingData.properties['Line 2 (Team Name or Text)'] = engravingDetailsRow[ engravingDetailsKey ];
								y += 1;
							} else if (y === 3) {
								engravingData.properties['Line 3 (Winner name or Additional Text)'] = engravingDetailsRow[ engravingDetailsKey ];
								y += 1;
							}

						} else if ( alternateFirstEngravingDetailsInputContainer ) {

							// if ( engravingDetailsRow[ engravingDetailsKey ] === 'NA' ) {
							// 	continue;
							// }

							if ( y === 1 ) {
								engravingData.properties[ 'Line 1' ] = engravingDetailsRow[ engravingDetailsKey ];
								y += 1;
							} else if ( y === 2 ) {
								engravingData.properties[ 'Line 2' ] = engravingDetailsRow[ engravingDetailsKey ];
								y += 1;
							} else if ( y === 3 ) {
								engravingData.properties[ 'Line 3' ] = engravingDetailsRow[ engravingDetailsKey ];
								y += 1;
							} else if ( y === 4 ) {
								engravingData.properties[ 'Line 4' ] = engravingDetailsRow[ engravingDetailsKey ];
								y += 1;
							}

						}

					}
				}
			}
		}

		// If no engraving data has been entered, abort
		var hasEngravingData = false;
		for ( var property in engravingData.properties ) {
			if (engravingData.properties.hasOwnProperty( property ) && engravingData.properties[ property ] !== '' ) {
				hasEngravingData = true;
			}
		}
		if ( false === hasEngravingData ) {
			console.log( 'No engraving data entered: not adding engraving product' );
			return;
		}

		// Wipe inputs so they don't make it into the trophy line item
		selectionState.clearLeagueNameAndEngravingDetailsInputs();

		w.engravingData = engravingData;
		//console.log("Test--engravingData-----",engravingData);
		function sendAddEngravingToCartRequest() {
			//console.log("Test--sendAddEngravingToCartRequest-----");
			// console.log( 'Adding engraving to cart with json data: ', w.engravingData);
			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				dataType: 'json',
				data: engravingData,
				success: function(){
					// console.log( 'Added engraving variant: ', selectionState.selectedEngravingVariant, ' to cart' );
					ajaxCart.load();
					// Add grey border css after league name and between engraving details rows
					// border-bottom: 1px solid #eee;
					// Have to use another callback to make sure elements are loaded in time

					ShopifyAPI.getCart(function() {
						//console.log("Test-------0");
						function addBordersToPropertyContainer(propertyContainer) {
							var foundEngravingDetailsRowIndices = [];

							var propertyNodes = propertyContainer.querySelectorAll( 'span' ), propertyNode;
							for (var y = 0, l2 = propertyNodes.length; y < l2; y++) {
								propertyNode = propertyNodes[y];
								var splitPropertyTextContent = propertyNode.textContent.split( ':' );
								if (splitPropertyTextContent.length === 2) {
									var propertyName = splitPropertyTextContent[0];
									if (propertyName.indexOf( 'League' ) !== -1) {
										propertyNode.style.borderBottom = '1px solid #eee';
									} else {
										var matchIndex = propertyName.match(/\d+/);
										if (null === matchIndex) {
											var index = 0;
										} else if (matchIndex.length > 0) { // ?
											var index = matchIndex[0];
										}

										if ( foundEngravingDetailsRowIndices.indexOf( index ) === -1 ) {
											if (typeof propertyNodes[ y - 1 ] !== 'undefined' ) { // single winner
												propertyNodes[y - 1].style.borderBottom = '1px solid #eee';
												foundEngravingDetailsRowIndices.push( index );
											} else {
												foundEngravingDetailsRowIndices.push( index );
											}
										}
									}
								}
							}
						}

						var cartContainer = d.getElementById( 'CartContainer' );

						(function(f) {
							var variantLink = cartContainer.querySelector( 'a[href*="' + selectionState.selectedEngravingVariant.id + '"]' );
							if (variantLink) {
								f();
							} else {
								setTimeout(f, 250);
							}
						})(function() {
							var allEgravingVariantIds = [];
							for (let i = 0, l = allEngravingProducts.length; i < l; i++) {
								for (var y = 0, l2 = allEngravingProducts[i].variants.length; y < l2; y++) {
									allEgravingVariantIds.push(allEngravingProducts[i].variants[y].id);
								}
							}

							window.engravingVariantToProductVariant = window.engravingVariantToProductVariant || {};
							window.engravingVariantToProductVariant[
								selectionState.selectedEngravingVariant.id
							] = selectionState.selectedVariant.id;

							var cartRowContainers = cartContainer.querySelectorAll( '.ajaxcart__row' );
							for (let i = 0, l = cartRowContainers.length; i < l; i++) {
								// var propertyContainer = cartRowContainers[i].querySelector( '.grid__item.three-quarters > p' ); //BS removed
								var propertyContainer = cartRowContainers[i].querySelector( '.cst-cst-grd .cst-cst-grd-thrqua > p' );

								var productLink = propertyContainer.firstElementChild.href;
								var splitProductLink = productLink.split( '?variant=' );
								var fullContainer, quantityCtrl;
								var minusQnt, plusQnt;

								if (splitProductLink.length !== 2) {continue;}
								if (allEgravingVariantIds.includes(parseInt(splitProductLink[1]))) {
									// Add borders for engraving note sets for readability
									addBordersToPropertyContainer(propertyContainer);
									// Disable quantity control for associated product
									qtyCtrlHelpers.disableForFlyoutByVariantId(
										window.engravingVariantToProductVariant[selectionState.selectedEngravingVariant.id],
										cartContainer, fullContainer
									);
									// Disable quantity control for engraving and hide remove button
									qtyCtrlHelpers.disableForFlyoutByVariantId(parseInt(splitProductLink[1]), cartContainer, fullContainer);
									fullContainer = propertyContainer.parentElement.parentElement;
									// if (fullContainer.classList.contains( 'grid' )) {  //BS removed
									if (fullContainer.classList.contains( 'cst-cst-grd' )) {
										quantityCtrl = fullContainer.querySelector( '.ajaxcart__qty' );
										if (quantityCtrl) {
											var removeBtn = quantityCtrl.querySelector( '.ajaxcart__qty--remove' );
											if (removeBtn) {
												removeBtn.style.display = 'none';
											}
										}
									}

								} else {
									var variantId = splitProductLink[1];
									if ( qtyCtrlHelpers.variantIdHasAssociatedEngravings( variantId ) ) {
										qtyCtrlHelpers.disableForFlyoutByVariantId( variantId, cartContainer, fullContainer );
									}

								}
							}


						});

					});

				},
				error: function( XMLHttpRequest, textStatus, errorThrown ) {
					 alert( errorThrown );
				}
			});
		}


		setTimeout( function() {
			ShopifyAPI.getCart(function() {
					// console.log( 'getCart callback' );
					sendAddEngravingToCartRequest();
			} );
		}, 1000 );

	});

	});

